export function generatePriceFilterNodes(minimumProductPrice: number, maximumProductPrice: number): any[] {
  const minimalNodes = [1, 2, 3, 4, 6, 7, 8, 9, 11, 12, 13, 14];
  const priceFilterNodes: number[] = [
    ...(maximumProductPrice < 15 ? minimalNodes : []),
    0, minimumProductPrice, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100, 110, 120, 130, 140, 150, 160, 170, 180, 190, 200, 210, 220, 230, 240, 250,
    265, 280, 295, 310, 325, 340, 355, 370, 385, 400, 415, 430, 445, 460, 475, 500,
    550, 600, 650, 700, 750, 800, 850, 900, 950, 1000,
    1100, 1200, 1300, 1400, 1500, 1600, 1700, 1800, 1900, 2000,
    2100, 2200, 2300, 2400, 2500, 2600, 2700, 2800, 2900, 3000,
    3100, 3200, 3300, 3400, 3500, 3600, 3700, 3800, 3900, 4000,
    4100, 4200, 4300, 4400, 4500, 4600, 4700, 4800, 4900, 5000,
    5500, 6000, 6500, 7000, 7500, 8000, 8500, 9000, 9500, 10000,
    11000, 12000, 13000, 14000, 15000, 16000, 17000, 18000, 19000,
    20000, 21000, 22000, 23000, 24000, 25000, 26000, 27000, 28000,
    29000, 30000, 31000, 32000, 33000, 34000, 35000, 36000, 37000,
    38000, 39000, 40000, 41000, 42000, 43000, 44000, 45000, 46000,
    47000, 48000, 49000, 50000, 55000, 60000, maximumProductPrice
  ];

  return priceFilterNodes.filter((step: number, index, self) =>
    step >= minimumProductPrice
    && step <= maximumProductPrice
    && self.indexOf(step) === index
  ).sort((stepA, stepB) => stepA - stepB).map((step) => ({
      value: step
    })
  )
}
